import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { chunk } from '../helpers'

import { Row, Content } from '../components/Layout.js'
import Hero from '../components/Hero'
import Article from '../components/Article'
import Footer from '../components/Footer'

const heroOptions = {
  header: 'Solutions',
  subtext: 'Our products and experiments are used throughout the public, private, and non-profit sectors to help people quickly implement solutions to the hardest problems they face.',
  background: 'citylapse'
  // backgroundImage
}

class Solutions extends Component {
  constructor (props) {
    super(props)
    this.state = {selectedTags: this.props.tags.map((tag) => tag.classname)}
  }
  componentWillMount () {
    this.props.setModal(false)
  }
  toggleTag (tag) {
    const selectedTags = [...this.state.selectedTags]
    const arrayPos = selectedTags.indexOf(tag)
    if (arrayPos === -1) {
      selectedTags.push(tag)
    } else {
      selectedTags.splice(arrayPos, 1)
    }
    this.setState({selectedTags})
  }
  render () {
    const {tags} = this.props
    const filteredSolutions = this.props.solutions.filter((solution) =>
      solution.tags.some((tag) => this.state.selectedTags.indexOf(tag) !== -1)
    )
    const solutions = chunk(filteredSolutions, 2)

    return (
      <div className='mainContainer'>
        <Hero options={heroOptions} />
        <section className='noTopPadding'>
          <Row>
            <Content classes={['contentFull']}>
              <ul className='filters'>
                {
                  tags.map(({name, classname: tag}, index) => (
                    <li key={index}>
                      <label htmlFor={`filter${index}`}>
                        {name}
                        <input type='checkbox' defaultChecked onChange={() => this.toggleTag(tag)} className='filter' name={`filter${index}`} id={`filter${index}`} />
                        <span />
                      </label>
                    </li>
                  ))
                }
              </ul>
            </Content>
          </Row>
          {
            solutions.map((row, index) =>
              <Row key={index}>
                {
                  row.map(({title, subtext, image, url, tags}, index) =>
                    <Content key={index} classes={tags}><Article title={title} subtext={subtext} image={image} url={url} active /></Content>
                  )
                }
              </Row>
            )
          }
        </section>
        <Footer />
      </div>
    )
  }
}

Solutions.propTypes = {
  setModal: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  solutions: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default Solutions



// WEBPACK FOOTER //
// ./src/containers/Solutions.js